import React, { useId, useState } from 'react';
import { uploadAPI, getImageUrl } from '../../../services/api';
import './ImageUploader.scss';

const ImageUploader = ({ value, onChange, label = 'Image' }) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const inputId = useId();

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      setError('Please select an image file');
      return;
    }

    // Validate file size (5MB)
    if (file.size > 5 * 1024 * 1024) {
      setError('Image size must be less than 5MB');
      return;
    }

    setError('');
    setUploading(true);

    try {
      const formData = new FormData();
      formData.append('image', file);

      const response = await uploadAPI.uploadImage(formData);
      if (response.data.success) {
        onChange(response.data.url);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="image-uploader">
      {label && <label className="uploader-label">{label}</label>}
      <div className="uploader-container">
        {value && (
          <div className="image-preview">
            <img src={getImageUrl(value)} alt="Preview" />
            <button
              type="button"
              className="remove-image"
              onClick={() => onChange('')}
            >
              ✕
            </button>
          </div>
        )}
        <div className="upload-area">
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            disabled={uploading}
            className="file-input"
            id={inputId}
          />
          <label htmlFor={inputId} className="upload-button">
            {uploading ? 'Uploading...' : value ? 'Change Image' : 'Upload Image'}
          </label>
        </div>
      </div>
      {error && <div className="upload-error">{error}</div>}
    </div>
  );
};

export default ImageUploader;
